/**
 * LINKO 磁吸軌道燈・自由配
 */
(function () {
  function $(root, sel) {
    return root.querySelector(sel);
  }

  function $$(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    return 'HK$' + n.toLocaleString('en-HK', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function findVariant(product, matcher) {
    if (!product || !product.variants || !product.variants.length) return null;
    var i;
    var v;
    if (typeof matcher === 'function') {
      for (i = 0; i < product.variants.length; i += 1) {
        v = product.variants[i];
        if (matcher(v)) return v;
      }
      return null;
    }
    var key = String(matcher || '').toLowerCase();
    for (i = 0; i < product.variants.length; i += 1) {
      v = product.variants[i];
      if (String(v.title || '').toLowerCase().indexOf(key) !== -1) return v;
    }
    if (product.variants.length === 1) return product.variants[0];
    return null;
  }

  function packLengths(meters, options) {
    var remaining = Math.round(Number(meters) * 10) / 10;
    var pieces = {};
    var i;
    var len;
    var n;
    for (i = 0; i < options.length; i += 1) {
      len = options[i];
      n = Math.floor((remaining + 0.001) / len);
      if (n > 0) {
        pieces[String(len)] = n;
        remaining = Math.round((remaining - n * len) * 10) / 10;
      }
    }
    if (remaining > 0.05) {
      len = options[options.length - 1];
      pieces[String(len)] = (pieces[String(len)] || 0) + 1;
    }
    return pieces;
  }

  function trackCount(pieces) {
    var n = 0;
    Object.keys(pieces || {}).forEach(function (k) {
      n += pieces[k] || 0;
    });
    return n;
  }

  function connectorRecipe(shape, count) {
    var n = Math.max(1, count);
    if (shape === 'l') return { I: Math.max(0, n - 2), L: 1, T: 0, X: 0, Lv: 0 };
    if (shape === 't') return { I: Math.max(0, n - 3), L: 0, T: 1, X: 0, Lv: 0 };
    if (shape === 'x') return { I: Math.max(0, n - 4), L: 0, T: 0, X: 1, Lv: 0 };
    if (shape === 'u') return { I: Math.max(0, n - 3), L: 2, T: 0, X: 0, Lv: 0 };
    return { I: Math.max(0, n - 1), L: 0, T: 0, X: 0, Lv: 0 };
  }

  function defaultLights(series, meters) {
    var m = Number(meters) || 0;
    var qty = {};
    if (series === 'e20') {
      qty.flood60 = Math.max(1, Math.round(m / 1.5));
      qty.spot24 = m >= 2 ? 1 : 0;
      if (m >= 3) qty.grille6 = 1;
    } else {
      qty.line60 = Math.max(1, Math.round(m / 1.5));
      qty.line30 = m >= 2.5 ? 1 : 0;
    }
    return qty;
  }

  function parseHash() {
    var hash = String(location.hash || '');
    if (hash.indexOf('#mt') !== 0) return null;
    var out = {};
    hash.replace(/^#mt&?/, '').split('&').forEach(function (part) {
      var i = part.indexOf('=');
      if (i < 1) return;
      out[part.slice(0, i)] = decodeURIComponent(part.slice(i + 1) || '');
    });
    return out;
  }

  function shareHash(state) {
    var lights = [];
    Object.keys(state.lights || {}).forEach(function (id) {
      if (state.lights[id] > 0) lights.push(id + ':' + state.lights[id]);
    });
    var extras = [];
    Object.keys(state.extras || {}).forEach(function (id) {
      if (state.extras[id] > 0) extras.push(id + ':' + state.extras[id]);
    });
    return '#mt&s=' + encodeURIComponent(state.series || '') +
      '&sh=' + encodeURIComponent(state.shape || '') +
      '&m=' + encodeURIComponent(String(state.meters || '')) +
      '&o=' + encodeURIComponent(state.outlet || '') +
      '&c=' + encodeURIComponent(state.color || '') +
      '&l=' + encodeURIComponent(lights.join(',')) +
      '&x=' + encodeURIComponent(extras.join(','));
  }

  function parsePairs(str) {
    var out = {};
    String(str || '').split(',').forEach(function (part) {
      var bits = part.split(':');
      if (bits[0] && Number(bits[1]) > 0) out[bits[0]] = Number(bits[1]);
    });
    return out;
  }

  function waHref(phone, text) {
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text);
  }

  function bind(root) {
    if (!root || root.getAttribute('data-mt-bound') === '1') return;
    root.setAttribute('data-mt-bound', '1');

    var cfgEl = root.querySelector('[data-mt-config]');
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (err) {
      return;
    }

    var state = {
      series: cfg.hintSeries || 'p20',
      shape: 'i',
      meters: 2,
      outlet: 'unsure',
      color: 'white',
      lights: {},
      extras: {},
      lightsTouched: false,
      extrasTouched: false
    };

    function product(key) {
      return (cfg.products || {})[key] || null;
    }

    function seriesMeta() {
      return (cfg.series || {})[state.series] || (cfg.series || {}).p20 || {};
    }

    function lightDefs() {
      return seriesMeta().lights || [];
    }

    function resolveLine(def) {
      if (!def) return null;
      if (def.enquire) {
        return {
          id: def.id,
          label: def.label,
          note: def.note || '',
          watts: def.watts || 0,
          enquire: true,
          qty: state.lights[def.id] || 0
        };
      }
      var p = product(def.product);
      var v = findVariant(p, def.match);
      return {
        id: def.id,
        label: def.label,
        note: def.note || '',
        watts: def.watts || 0,
        enquire: false,
        product: p,
        variant: v,
        qty: state.lights[def.id] || 0
      };
    }

    function buildKit() {
      var meta = seriesMeta();
      var lengths = meta.trackLengths || [1.5, 1, 0.5];
      var pieces = packLengths(state.meters, lengths);
      var tracks = [];
      var watts = 0;
      var total = 0;
      var count = 0;
      var missing = [];

      (meta.tracks || []).forEach(function (def) {
        var qty = pieces[String(def.meters)] || 0;
        if (!qty) return;
        var p = product(def.product);
        var v = findVariant(p, def.match);
        var line = {
          key: 'track-' + def.meters,
          role: '軌道 ' + def.meters + ' 米',
          label: def.label,
          qty: qty,
          watts: 0,
          enquire: !v,
          product: p,
          variant: v
        };
        tracks.push(line);
        count += qty;
        if (v) total += v.price * qty;
        else missing.push(line.label);
      });

      var conns = connectorRecipe(state.shape, trackCount(pieces));
      var accessories = [];
      (meta.connectors || []).forEach(function (def) {
        var qty = state.extrasTouched ? (state.extras[def.id] || 0) : (conns[def.id] || 0);
        if (!state.extrasTouched) state.extras[def.id] = qty;
        if (!qty) return;
        var p = product(def.product);
        var v = findVariant(p, def.match);
        accessories.push({
          key: 'acc-' + def.id,
          role: def.label,
          label: def.label,
          qty: qty,
          watts: 0,
          enquire: !v,
          product: p,
          variant: v
        });
        count += qty;
        if (v) total += v.price * qty;
        else missing.push(def.label);
      });

      var powerQty = state.extrasTouched ? (state.extras.power || 0) : 1;
      if (!state.extrasTouched) state.extras.power = powerQty;
      if (powerQty > 0 && meta.power) {
        var pp = product(meta.power.product);
        var pv = findVariant(pp, meta.power.match);
        accessories.push({
          key: 'acc-power',
          role: '電源',
          label: meta.power.label,
          qty: powerQty,
          watts: 0,
          enquire: !pv,
          product: pp,
          variant: pv
        });
        count += powerQty;
        if (pv) total += pv.price * powerQty;
        else missing.push(meta.power.label);
      }

      if (meta.clip && (state.extras.clip || 0) > 0) {
        var cp = product(meta.clip.product);
        var cv = findVariant(cp, meta.clip.match);
        accessories.push({
          key: 'acc-clip',
          role: meta.clip.label,
          label: meta.clip.label,
          qty: state.extras.clip,
          watts: 0,
          enquire: !cv,
          product: cp,
          variant: cv
        });
        count += state.extras.clip;
        if (cv) total += cv.price * state.extras.clip;
      }

      var lights = [];
      lightDefs().forEach(function (def) {
        var line = resolveLine(def);
        if (!line.qty) return;
        lights.push(line);
        watts += (line.watts || 0) * line.qty;
        count += line.qty;
        if (line.variant) total += line.variant.price * line.qty;
        else if (line.enquire) missing.push(line.label);
        else missing.push(line.label);
      });

      return {
        pieces: pieces,
        tracks: tracks,
        lights: lights,
        accessories: accessories,
        watts: watts,
        budget: meta.powerWatts || 120,
        total: total,
        count: count,
        missing: missing,
        rows: tracks.concat(lights, accessories)
      };
    }

    function shareUrl() {
      var base = cfg.sharePath || location.pathname;
      return location.origin + base + shareHash(state);
    }

    function setChip(name, id) {
      $$(root, '[data-mt="' + name + '"]').forEach(function (btn) {
        var on = btn.getAttribute('data-id') === String(id);
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function paintSchematic() {
      var svg = $(root, '[data-mt-schematic]');
      if (!svg) return;
      var outlet = state.outlet;
      var mark = '';
      if (outlet === 'center') mark = '<circle class="mt-out" cx="140" cy="90" r="7"></circle>';
      else if (outlet === 'wall') mark = '<circle class="mt-out" cx="36" cy="90" r="7"></circle>';
      else if (outlet === 'corner') mark = '<circle class="mt-out" cx="52" cy="52" r="7"></circle>';
      var lines = {
        i: '<path d="M40 90 H240"></path>',
        l: '<path d="M50 50 V150 H200"></path>',
        t: '<path d="M40 70 H240"></path><path d="M140 70 V160"></path>',
        x: '<path d="M40 90 H240"></path><path d="M140 30 V150"></path>',
        u: '<path d="M60 40 V150 H220 V40"></path>'
      };
      svg.innerHTML = '<rect class="mt-ceil" x="8" y="8" width="264" height="164" rx="16"></rect>' +
        '<g class="mt-rail">' + (lines[state.shape] || lines.i) + '</g>' +
        mark +
        '<text x="20" y="188" class="mt-cap">天花俯視 · ' + escapeHtml((cfg.shapes[state.shape] || {}).label || '') + '</text>';
    }

    function rowHtml(line, kind) {
      var img = '';
      if (line.product && line.product.image) {
        img = '<img src="' + line.product.image + '" alt="" width="64" height="64">';
      } else {
        img = '<span class="mt-ph" aria-hidden="true"></span>';
      }
      var price = line.variant ? line.variant.priceLabel : (line.enquire ? '問價' : '—');
      var href = line.product && line.product.url ? line.product.url : '#';
      var name = line.variant && line.product
        ? line.product.title + (line.variant.title && line.variant.title !== 'Default Title' ? ' · ' + line.variant.title : '')
        : line.label;
      var badge = line.enquire ? '<span class="mt-badge">WhatsApp 問貨</span>' : '';
      var qtyCtrl = '';
      if (kind === 'light' || kind === 'extra') {
        qtyCtrl = '<div class="mt-qty">' +
          '<button type="button" data-mt-qty="' + kind + '" data-id="' + line.id + '" data-delta="-1" aria-label="減少">−</button>' +
          '<span>' + line.qty + '</span>' +
          '<button type="button" data-mt-qty="' + kind + '" data-id="' + line.id + '" data-delta="1" aria-label="增加">+</button>' +
          '</div>';
      } else {
        qtyCtrl = '<div class="mt-qty mt-qty--static"><span>× ' + line.qty + '</span></div>';
      }
      return '<article class="mt-row">' +
        '<a class="mt-row__media" href="' + href + '">' + img + '</a>' +
        '<div class="mt-row__copy">' +
          '<p class="mt-row__role">' + escapeHtml(line.role || line.label) + badge + '</p>' +
          '<a href="' + href + '">' + escapeHtml(name) + '</a>' +
          '<p class="mt-row__price">' + escapeHtml(price) + (line.watts ? ' · ' + line.watts + 'W' : '') + '</p>' +
        '</div>' + qtyCtrl +
        '</article>';
    }

    function paintLights() {
      var wrap = $(root, '[data-mt-lights]');
      if (!wrap) return;
      wrap.innerHTML = lightDefs().map(function (def) {
        var line = resolveLine(def);
        var price = line.variant ? line.variant.priceLabel : (line.enquire ? '問貨' : '—');
        return '<article class="mt-card' + (line.enquire ? ' is-ask' : '') + '">' +
          '<div class="mt-card__top">' +
            '<strong>' + escapeHtml(def.label) + '</strong>' +
            '<span>' + escapeHtml(price) + '</span>' +
          '</div>' +
          '<p>' + escapeHtml(def.note || '') + (def.watts ? ' · ' + def.watts + 'W' : '') + '</p>' +
          '<div class="mt-qty">' +
            '<button type="button" data-mt-qty="light" data-id="' + def.id + '" data-delta="-1" aria-label="減少">−</button>' +
            '<span>' + (state.lights[def.id] || 0) + '</span>' +
            '<button type="button" data-mt-qty="light" data-id="' + def.id + '" data-delta="1" aria-label="增加">+</button>' +
          '</div>' +
        '</article>';
      }).join('');
    }

    function paintExtras() {
      var wrap = $(root, '[data-mt-extras]');
      if (!wrap) return;
      var meta = seriesMeta();
      var items = (meta.connectors || []).concat(meta.power ? [Object.assign({ id: 'power' }, meta.power)] : []);
      if (meta.clip) items = items.concat([Object.assign({ id: 'clip' }, meta.clip)]);
      wrap.innerHTML = items.map(function (def) {
        var p = product(def.product);
        var v = findVariant(p, def.match);
        var qty = state.extras[def.id] || 0;
        return '<article class="mt-card">' +
          '<div class="mt-card__top"><strong>' + escapeHtml(def.label) + '</strong><span>' + escapeHtml(v ? v.priceLabel : '問貨') + '</span></div>' +
          '<p>' + escapeHtml(def.note || '') + '</p>' +
          '<div class="mt-qty">' +
            '<button type="button" data-mt-qty="extra" data-id="' + def.id + '" data-delta="-1" aria-label="減少">−</button>' +
            '<span>' + qty + '</span>' +
            '<button type="button" data-mt-qty="extra" data-id="' + def.id + '" data-delta="1" aria-label="增加">+</button>' +
          '</div>' +
        '</article>';
      }).join('');
    }

    function paint(persist) {
      if (!state.lightsTouched) state.lights = defaultLights(state.series, state.meters);
      if (!state.extrasTouched) {
        var pieces = packLengths(state.meters, seriesMeta().trackLengths || [1.5, 1, 0.5]);
        state.extras = connectorRecipe(state.shape, trackCount(pieces));
        state.extras.power = 1;
        if (seriesMeta().clip) state.extras.clip = Math.max(2, Math.ceil((Number(state.meters) || 1) * 2));
      }

      setChip('series', state.series);
      setChip('shape', state.shape);
      setChip('meters', String(state.meters));
      setChip('outlet', state.outlet);
      setChip('color', state.color);
      var metersInput = $(root, '[data-mt-meters]');
      if (metersInput && document.activeElement !== metersInput) metersInput.value = state.meters;

      paintSchematic();
      paintLights();
      paintExtras();

      var kit = buildKit();
      var list = $(root, '[data-mt-kit]');
      if (list) {
        list.innerHTML = kit.rows.map(function (row) {
          var kind = 'track';
          if (row.id && state.lights[row.id] != null) kind = 'light';
          return rowHtml(row, kind);
        }).join('') || '<p class="mt-empty">揀軌道同燈具，清單會即時出現。</p>';
      }

      var countEl = $(root, '[data-mt-count]');
      var totalEl = $(root, '[data-mt-total]');
      var wattEl = $(root, '[data-mt-watts]');
      var warnEl = $(root, '[data-mt-warn]');
      if (countEl) countEl.textContent = String(kit.count);
      if (totalEl) totalEl.textContent = kit.total ? formatMoney(kit.total) : '問價';
      if (wattEl) wattEl.textContent = kit.watts + ' / ' + kit.budget + 'W';
      if (warnEl) {
        var over = kit.watts > kit.budget;
        warnEl.hidden = !over;
        if (over) warnEl.textContent = '燈具約 ' + kit.watts + 'W，超過呢組電源 ' + kit.budget + 'W。請減少燈數，或者再加一組電源。';
      }

      var gapEl = $(root, '[data-mt-gap]');
      if (gapEl) {
        var gaps = [];
        if (state.color === 'black' && state.series === 'p20') gaps.push('P20 黑色款店內暫時未上架');
        if (kit.missing.length) gaps.push('未上架／要問貨：' + kit.missing.join('、'));
        gapEl.hidden = !gaps.length;
        gapEl.textContent = gaps.join('。');
      }

      var lines = [
        '你好 LINKO，我想自由配磁吸軌道燈：',
        '系列：' + ((cfg.series[state.series] || {}).label || state.series),
        '形狀：' + ((cfg.shapes[state.shape] || {}).label || state.shape),
        '軌道：' + state.meters + ' 米',
        '出線：' + ((cfg.outlets[state.outlet] || {}).label || state.outlet),
        '顏色：' + (state.color === 'black' ? '黑' : '白')
      ];
      kit.rows.forEach(function (row) {
        lines.push('- ' + (row.label || '') + ' × ' + row.qty + (row.enquire ? '（問貨）' : ''));
      });
      if (kit.total) lines.push('合計約 ' + formatMoney(kit.total));
      lines.push('負載約 ' + kit.watts + 'W / ' + kit.budget + 'W');
      lines.push('配置：' + shareUrl());
      lines.push('想問有冇貨同安裝。');

      var wa = $(root, '[data-mt-wa]');
      if (wa) wa.setAttribute('href', waHref(cfg.wa || '85294013777', lines.join('\n')));

      root.setAttribute('data-ready', '1');
      if (persist !== false) {
        try {
          history.replaceState({ mt: true }, '', location.pathname + location.search + shareHash(state));
        } catch (err) {}
      }
    }

    function applySaved(saved) {
      if (!saved) return;
      if (saved.s && cfg.series[saved.s]) state.series = saved.s;
      if (saved.sh && cfg.shapes[saved.sh]) state.shape = saved.sh;
      if (saved.m && Number(saved.m) > 0) state.meters = Number(saved.m);
      if (saved.o && cfg.outlets[saved.o]) state.outlet = saved.o;
      if (saved.c === 'black' || saved.c === 'white') state.color = saved.c;
      if (saved.l) {
        state.lights = parsePairs(saved.l);
        state.lightsTouched = true;
      }
      if (saved.x) {
        state.extras = parsePairs(saved.x);
        state.extrasTouched = true;
      }
    }

    root.addEventListener('click', function (ev) {
      var chip = ev.target.closest('[data-mt]');
      if (chip) {
        var name = chip.getAttribute('data-mt');
        var id = chip.getAttribute('data-id');
        if (name === 'series') {
          state.series = id;
          state.lightsTouched = false;
          state.extrasTouched = false;
        } else if (name === 'shape') {
          state.shape = id;
          state.extrasTouched = false;
        } else if (name === 'meters') {
          state.meters = Number(id);
          state.lightsTouched = false;
          state.extrasTouched = false;
        } else if (name === 'outlet') {
          state.outlet = id;
        } else if (name === 'color') {
          state.color = id;
        }
        paint();
        return;
      }

      var qtyBtn = ev.target.closest('[data-mt-qty]');
      if (qtyBtn) {
        var kind = qtyBtn.getAttribute('data-mt-qty');
        var key = qtyBtn.getAttribute('data-id');
        var delta = Number(qtyBtn.getAttribute('data-delta')) || 0;
        if (kind === 'light') {
          state.lightsTouched = true;
          state.lights[key] = Math.max(0, Math.min(20, (state.lights[key] || 0) + delta));
        } else {
          state.extrasTouched = true;
          state.extras[key] = Math.max(0, Math.min(20, (state.extras[key] || 0) + delta));
        }
        paint();
        return;
      }

      if (ev.target.closest('[data-mt-reset]')) {
        state = {
          series: cfg.hintSeries || 'p20',
          shape: 'i',
          meters: 2,
          outlet: 'unsure',
          color: 'white',
          lights: {},
          extras: {},
          lightsTouched: false,
          extrasTouched: false
        };
        paint();
        return;
      }

      if (ev.target.closest('[data-mt-cart]')) {
        addToCart();
      }
    });

    var metersInput = $(root, '[data-mt-meters]');
    if (metersInput) {
      metersInput.addEventListener('input', function () {
        var n = Number(metersInput.value);
        if (!n || n < 0.5) return;
        state.meters = Math.min(20, Math.round(n * 10) / 10);
        state.lightsTouched = false;
        state.extrasTouched = false;
        paint();
      });
    }

    function setStatus(text, isError) {
      var el = $(root, '[data-mt-status]');
      if (!el) return;
      el.hidden = !text;
      el.textContent = text || '';
      el.classList.toggle('is-error', !!isError);
    }

    function addToCart() {
      var kit = buildKit();
      var items = [];
      kit.rows.forEach(function (row) {
        if (row.variant && row.variant.id && row.qty > 0 && !row.enquire) {
          items.push({ id: row.variant.id, quantity: row.qty });
        }
      });
      var btn = $(root, '[data-mt-cart]');
      if (!items.length) {
        setStatus('清單未有可落單產品。可 WhatsApp 問未上架嘅格柵燈／射燈，或者先加軌道同線條燈。', true);
        return;
      }
      if (btn) btn.disabled = true;
      setStatus('加入緊購物車…', false);
      var addUrl = cfg.cartAdd || '/cart/add.js';
      if (addUrl.indexOf('.js') === -1) addUrl += '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || '加入失敗');
          return data;
        });
      }).then(function () {
        document.dispatchEvent(new CustomEvent('afterCartChanged'));
        window.location.href = cfg.cartUrl || '/cart';
      }).catch(function (err) {
        if (btn) btn.disabled = false;
        setStatus(err.message || '加入購物車失敗，請再試或 WhatsApp 我哋。', true);
      });
    }

    applySaved(parseHash());
    paint(false);
  }

  function boot() {
    $$(document, '[data-mag-track]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
